export default __webpack_public_path__ + "static/media/ic_pause.b9bdf7d3.svg";